export const commonTheme = {
  authThemeImage1: {
    zIndex: 1,
    position: 'absolute',
    bottom: '1.4rem',
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  authThemeImage1Style: {
    width: '80%',
  },
  authThemeImage2: {
    position: 'absolute',
    bottom: '1.4rem',
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  authThemeImage2Style: {
    width: '140%',
  },
};
